import React, { useState, useEffect, useRef } from "react";
import './Dashboard.css';
import { FaShoppingCart, FaSignInAlt, FaUserCheck, FaUserTimes } from 'react-icons/fa';
import { dashboardCount, sameDatesAttendanceForItm, userLoginDashboard, differentDatesAttendanceForItm } from "../../../../services/dashboard";
import { differenceInBusinessDays, format, isSameDay } from "date-fns";
import { capitalizeFirstLetter, convertToIST, getFileName } from "../../../../utils/validations";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { getAllDistrictBihar } from "../../../../services/monthlyAttendanceService";
const Dashboard = () => {
  const date = new Date();
  // const todayDate = date.toDateString();
  const apiDate = format(date, 'dd-M-yyyy');

  const [dashboardData, setDashboardData] = useState({ registeredEmployees: 0, onboardedEmployees: 0, presentToday: 0, absentToday: 0, });
  const effectRan = useRef();
  const [userData, setUSerData] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [fromDate, setFromDate] = useState(date);
  const [toDate, setToDate] = useState(date);
  const [errors, setErrors] = useState({});
  const [sameDayAttendance, setSameDayAttendance] = useState([]);
  const [differenceDayAttendace, setDifferenceDayAttendance] = useState();

  const [startDate, setStartDate] = useState(date);
  const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');
  const itmDistrict = localStorage.getItem("districtName");
  const itmDistrictId = localStorage.getItem("districtId");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // console.log(apiDate);


  const fetchDashboardCount = async () => {
    const data = await dashboardCount();
    setDashboardData({
      registeredEmployees: data.totalRegisterEmployees || 0,
      onboardedEmployees: data.activePostings || 0,
      presentToday: data.todayPresentCount || 0,
      absentToday: data.todayAbsentCount || 0,
    });
  }
  useEffect(() => {
    if (!effectRan.current) {
      fetchDashboardCount();
    }
    return () => {
      effectRan.current = true;
    }


  }, []);




  const getUserDetails = async () => {
    const data = await userLoginDashboard(employeeUniqueId, startDate);
    setUSerData(data);

  }


  const handleFromDateChange = (date) => {
    setFromDate(date)
    // setToDate('');
  }
  const handleToDateChange = (date) => {
    setToDate(date);
  }
  // Run when employee ID or date changes
  useEffect(() => {
    getUserDetails();
  }, [employeeUniqueId, startDate]); // Correct dependencies


  // const lastRecord = userData?.dailyRecords?.at(-1);
  useEffect(() => {

    const fetchDistricts = async () => {
      try {
        const data = await getAllDistrictBihar();
        setDistrictOptions(data.map(item => ({
          value: item.districtId,
          label: item.districtName,
        })));
      } catch (err) {
        console.error('Error fetching districts:', err);
        setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
      }
    };
    fetchDistricts();

  }, []);

  useEffect(() => {
    const fetchAttendance = async () => {
      if (!itmDistrictId || !fromDate || !toDate) return;

      setLoading(true);
      setError(null);

      try {
        const same = isSameDay(fromDate, toDate);

        if (same) {
          const data = await sameDatesAttendanceForItm(itmDistrictId, fromDate, toDate);
          setSameDayAttendance(data);
          setDifferenceDayAttendance(null);
        } else {
          const data = await differentDatesAttendanceForItm(itmDistrictId, fromDate, toDate);
          setDifferenceDayAttendance(data);
          setSameDayAttendance(null);
        }
      } catch (err) {
        console.error('Attendance fetch error:', err);
        setError('Failed to load attendance data');
        setSameDayAttendance(null);
        setDifferenceDayAttendance(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAttendance();
  }, [fromDate, toDate, itmDistrictId]); // <-- Re-run when dates or district change
  // const handleInputChange = (selectedOption, field) => {
  //   const value = selectedOption ? selectedOption.value : null;
  //   switch (field) {

  //     case 'district':
  //       setDistrict(value);
  //       setDistrictId(value);
  //       break;

  //     default:
  //       break;
  //   }
  //   setErrors(prev => ({ ...prev, [field]: null }));
  // };
  const getAttendanceStatus = (record) => {
    if (record.holiday) return "Holiday";
    if (record.weekOff) return "Week Off";
    if (record.present) return "Present";
    if (record.absent) return "Absent";
    if (record.onLeave) return "Leave";
    return "—"; // fallback if nothing is marked
  };
  const handleRowClick = (rowDate) => {
    const clickedDate = new Date(rowDate); // assuming rowDate is ISO string or valid date
    setFromDate(clickedDate);
    setToDate(clickedDate);
    // No need to call API here – useEffect will auto-run
  };

  // if (isSameDay(fromDate, toDate)) {
  //   console.log("Dates are SAME");
  // } else {
  //   console.log("Dates are different");
  // }



  return (
    <div className="dashboard-page">
      {/* <div className="dashboard-maincontainer">
        <div className="dashboard-row">
          <div className="dashboard-card bg-c-blue">
            <h5>Total Employees Registered </h5>
            <div className="dashboard-card-content">
              <FaShoppingCart size={32} />
              <h3>{dashboardData.registeredEmployees}</h3>
            </div>
          </div>

          <div className="dashboard-card bg-c-green">
            <h5>Onboarded Employees</h5>
            <div className="dashboard-card-content">
              <FaSignInAlt size={30} />
              <h3>{dashboardData.onboardedEmployees}</h3>
            </div>
          </div>

          <div className="dashboard-card bg-c-yellow">
            <h5>Today Present</h5>
            <div className="dashboard-card-content">
              <FaUserCheck size={32} />
              <h3>{dashboardData.presentToday}</h3>
            </div>
          </div>

          <div className="dashboard-card bg-c-red">
            <h5>Today Absent/Leave</h5>
            <div className="dashboard-card-content">
              <FaUserTimes size={32} color="#fff" />
              <h3>{dashboardData.absentToday}</h3>
            </div>
          </div>
        </div>
      </div > */}

      <div className="new-dashboard-dash">
        <div className="current-month-date-dash">
          <div className="current-month-dash">
            <div className="select-date-text-dash">
              <div className="month-text-dash">Month :</div>
              <div className="cal-dropdwon-my">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="MMMM-yyyy"
                  showMonthYearPicker
                  // showFullMonthYearPicker
                  // showPopperArrow={false}
                  maxDate={date}

                />
              </div>


            </div>

            <div className="content-data-for-month-dash">
              <div className="present-days-dash">
                <div className="data-user-values1">{userData.presentCount}</div>
                <div className="data-user-label">No of Days Present</div>

              </div>
              <div className="present-days-dash">
                <div className="data-user-values2">{userData.absentCount}</div>
                <div className="data-user-label">No of Days Absent</div>
              </div>

              <div className="present-days-dash leave-card">
                <div className="data-user-values3">{userData.approvedLeaveCount ?? 0}</div>
                <div className="data-user-label">No of  Leaves</div>
                <div className="tooltip-box">
                  Casual Leaves: <strong>{userData.casualLeaveCount ?? 0}</strong>
                  <br />
                  LOP Leaves: <strong>{userData.lopLeaveCount ?? 0}</strong>
                </div>
              </div>
            </div>


          </div>
          <div className="current-date-dash">
            <p className="mt-2 p-text-dash">Current Date <span>{format(date, 'dd-MM-yyyy')}</span></p>
            <div className=" mt-2   content-data-for-month-dash">
              <div className="present-days-dash">
                <div className="data-user-label">Attendance Time</div>
                <div className="data-user-today">
                  {userData?.todayStatus === "Present" && userData?.todayAttendanceTime
                    ? convertToIST(format(new Date(), 'yyyy-MM-dd'), userData.todayAttendanceTime)
                    : "—"}
                </div>
              </div>

              <div className="present-days-dash">
                <div className="data-user-label">Attendance Status</div>
                <div className="data-user-today">
                  {userData?.todayStatus === "Present" ? "Present" : "Not Marked"}
                </div>
              </div>

            </div>

          </div>

        </div>
        <div>

        </div>

        <div className="user-first-table-dash">
          <div className="user-details-header">Daywise Attendance Report - <span>{format(startDate, 'MMMM yyyy')}</span></div>
          <div className="user-main-table">

            <table className="table-dash">
              <thead className="table-head-dash">
                <tr >
                  <th>S.No</th>
                  <th> Attendance Date</th>
                  <th>Attendance Status</th>
                  <th>Attendance Time</th>
                  <th>Working Location</th>
                  <th>Location Status</th>
                  <th>Remarks</th>
                  <th>Attendance Photo</th>
                </tr>
              </thead>
              <tbody className="table-body-dash">
                {userData?.dailyRecords?.length > 0 ? (
                  userData.dailyRecords.map((record, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{format(record.attendanceDate, 'dd-MM-yyyy')}</td>
                      <td>{getAttendanceStatus(record)}</td>
                      <td>
                        {record.attendanceTime ? convertToIST(record.attendanceDate, record.attendanceTime) : "-"}
                      </td>
                      <td>
                        {record.isWorkLocation === true
                          ? (record.workLocationName?.trim() || "-")
                          : (record.godownName?.trim() || "-")}
                      </td>
                      <td>{record.present && (record.remarks === null || record.remarks === ""|| record.remarks==="null"||record.remarks==="Inside the godown") ? "In the location" : (record.remarks && record.present ? "Not in the location" : "-")}</td>

                      <td>{record.remarks==="null"||record.remarks === ""||record.remarks === null||record.remarks==="Inside the godown"?"-" : record.remarks}</td>
                      <td>
                        {/* {getFileName(record.selfieUrl)} */}
                        <span className="employee-selfie">{record?.selfieUrl ? (
                          <a
                            href={record.selfieUrl.startsWith("http")
                              ? record.selfieUrl
                              : `${process.env.REACT_APP_FILE_BASE_URL}/${record.selfieUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}</span></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center', padding: '1rem' }}>
                      {userData?.dailyRecords ? 'No attendance data available.' : 'Loading attendance data…'}
                    </td>
                  </tr>
                )}
              </tbody>

            </table>


          </div>
        </div>





        <div> </div>

      </div>
    </div>
  );
};

export default Dashboard;
